<div class="spin-wheel">
    <span class="spin-wheel_spoke"></span>
    <span class="spin-wheel_spoke"></span>
    <span class="spin-wheel_spoke"></span>
    <span class="spin-wheel_spoke"></span>
    <span class="spin-wheel_spoke"></span>
    <span class="spin-wheel_spoke"></span>
    <span class="spin-wheel_spoke"></span>
    <span class="spin-wheel_spoke"></span>
    <span class="spin-wheel_spoke"></span>
    <span class="spin-wheel_spoke"></span>
    <span class="spin-wheel_spoke"></span>
    <span class="spin-wheel_spoke"></span>
</div>